import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlContainer, NgForm } from '@angular/forms';

let counter = 0;

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }
    ]
})
export class CheckboxComponent implements ControlValueAccessor {
    constructor() {
        this.id = `checkbox-${counter++}`;
    }

    @Input() disabled: boolean;
    @Input() allowUnknown: boolean;

    @Output() stateChange = new EventEmitter<boolean>();

    readonly id: string;

    get state(): 'checked' | 'empty' | 'unknown' {
        if (this.allowUnknown) {
            if (this._value === true) return 'checked';
            if (this._value === false) return 'empty';
            return 'unknown';
        } else {
            return this._value ? 'checked' : 'empty';
        }
    }

    private _onChange = (obj: boolean) => { };
    private _value: boolean;

    //ControlValueAccessor
    writeValue(obj: boolean): void {
        this._value = obj;
    }

    registerOnChange(fn: (obj: boolean) => void): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
    //ControlValueAccessor

    onChange() {
        if (this.disabled) return;

        if (this.allowUnknown) {
            if (this._value === true) {
                this._value = false;
            } else if (this._value === false) {
                this._value = undefined;
            } else {
                this._value = true;
            }
        } else {
            this._value = !this._value;
        }

        this.emitChange();
    }

    private emitChange() {
        this._onChange(this._value);
        this.stateChange.emit(this._value);
    }
}
